/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_HintInputs */

const cs_property_ai_hint = /** @type {(inputs: Property_Ai_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generování katalogového PDF.`)
};

const en_property_ai_hint = /** @type {(inputs: Property_Ai_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalog PDF generation.`)
};

/**
* | output |
* | --- |
* | "Catalog PDF generation." |
*
* @param {Property_Ai_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_hint = /** @type {((inputs?: Property_Ai_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_hint(inputs)
	return cs_property_ai_hint(inputs)
});